module.exports = __webpack_public_path__ + "img/drop.f799e73f.png";